import Vue from 'vue';
import InitComponent from './components/init/init.vue';
import {Constants as constants} from '../../config/constants';

export class ExportMenu {
    private static instance = null as unknown as Vue;

    constructor() {
        this.initChart();
    }

    private initChart() {
        if (!ExportMenu.instance) {
            ExportMenu.instance = new Vue({
                el: `#${constants.exportMenuId}`,
                render: (h) => h(InitComponent),
                components: {
                    init: InitComponent
                }
            });
        }
    }
}
